import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout";
import { Dashboard } from "./componants/admin/Dashboard";
import { Profile } from "./componants/profile/Profile";
import { Setting } from "./componants/setting/Setting";
import { User } from "./componants/user/User";
import "bootstrap/dist/css/bootstrap.min.css";
import LoginPage from "./componants/auth/Login";
import RequireAuth from "./componants/auth/RequireAuth";
import RedirectIfLoggedIn from "./componants/auth/RedirectIfLoggedIn";
import UserProfilePage from "./componants/user/UserById";
import AllBlogs from "./componants/blogsPage/AllBlogs";
import CreateBlogs from "./componants/blogsPage/CreateBlogs";
import UpdateBlogs from "./componants/blogsPage/UpdateBlogs";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreatePlan from "./componants/memberPlan/CreatePlan";
import { MembershipPlan } from "./componants/memberPlan/Plan";
import UpdatePlan from "./componants/memberPlan/UpdatePlane";
import { UserPlan } from "./componants/user/UserPlan";
import { UserQueries } from "./componants/pages/UsersQueries";
import { UserReports } from "./componants/pages/UserReports";
import AdminChatPanel from "./componants/pages/AdminChatPane";
function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="admin-login" replace />} />
          <Route element={<RedirectIfLoggedIn />}>
            <Route path="admin-login" element={<LoginPage />} />
          </Route>
          {/* Protected Routes */}
          <Route element={<RequireAuth />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="users" element={<User />} />
            <Route path="user-details/:id" element={<UserProfilePage />} />
            <Route path="blogs" element={<AllBlogs />} />
            <Route path="create-blog" element={<CreateBlogs />} />
            <Route path="update/blog/:slug" element={<UpdateBlogs />} />
            <Route path="settings" element={<Setting />} />
            <Route path="create/plans" element={<CreatePlan />} />
            <Route path="get/plans" element={<MembershipPlan />} />
            <Route path="update/plan/:id" element={<UpdatePlan />} />
            <Route path="all/users/plan" element={<UserPlan />} />
            <Route path="queries" element={<UserQueries />} />
            <Route path="reports" element={<UserReports />} />
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Setting />} />
            <Route path="admin-Chat-Panel" element={<AdminChatPanel />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
